import { render, staticRenderFns } from "./intelFurniture.vue?vue&type=template&id=6770cbe6&scoped=true&"
import script from "./intelFurniture.vue?vue&type=script&lang=ts&"
export * from "./intelFurniture.vue?vue&type=script&lang=ts&"
import style0 from "./intelFurniture.vue?vue&type=style&index=0&id=6770cbe6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6770cbe6",
  null
  
)

export default component.exports